import { useQueries } from '@tanstack/react-query';

type DocumentAudioSegment = {
  id: number;
  startSeconds: number;
  endSeconds: number;
  speaker: string;
};

type DocumentAudio = {
  url: string;
  segments: DocumentAudioSegment[];
};

/** Recording URL per cited recording, keyed by file id, used to play verify evidence.
 *  A document can be written from several meetings, so each is fetched on its own — one URL for
 *  the whole verdict would seek into the wrong file for a segment from another meeting. */
export function useDocumentAudio(documentId: string | undefined, fileIds: string[]) {
  const results = useQueries({
    queries: fileIds.map(fileId => ({
      queryKey: ['documents', documentId, 'audio', { fileId }],
      enabled: !!documentId,
      // A 404 means this recording has no audio, which retrying cannot change.
      retry: false,
    })),
  });

  return new Map(
    results.flatMap((result, index): [string, string][] => {
      const url = (result.data as DocumentAudio | undefined)?.url;
      return url ? [[fileIds[index], url]] : [];
    }),
  );
}
